import { Spin } from 'antd';
import { TaskStatusType } from 'app/containers/Task/slice/types';
import styled from 'styled-components';

interface IStatusCircleIconProps {
  $status: TaskStatusType;
}

export const StatusCircleIcon = styled('div')<IStatusCircleIconProps>`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background: ${({ theme, $status }) => {
    return theme.taskStatusColor[$status];
  }};
`;

export const Spinner = styled(Spin)`
  margin: auto;
`;

export const WarningCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background: #ffa39e;
  margin: auto 0 auto 7px;
`;
